'use client';
import { polymorphicFactory, Flex, Tab } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { useState, useRef, useEffect } from 'react';
import classes from './TabbedNavigationHorizontal.module.css.mjs';

const TabbedNavigationHorizontal = polymorphicFactory(
  (props, ref) => {
    const { mod, tabs, align, component = "div", initialSelectedTab, onTabClick, className, ...rest } = props;
    const [selectedTab, setSelectedTab] = useState(initialSelectedTab || tabs[0].id || tabs[0].text);
    const [underlineStyle, setUnderlineStyle] = useState({});
    const tabRefs = useRef([]);
    const [isInitialRender, setIsInitialRender] = useState(true);
    useEffect(() => {
      const selectedTabElement = tabRefs.current.find((tab) => tab.id === selectedTab);
      if (selectedTabElement) {
        setUnderlineStyle({
          width: `${selectedTabElement.offsetWidth}px`,
          transform: `translateX(${selectedTabElement.offsetLeft}px)`
        });
      }
    }, [selectedTab, align]);
    return /* @__PURE__ */ React.createElement(
      Flex,
      {
        role: "tablist",
        mod,
        component,
        className: clsx("kohler-tabbed-navigation-horizontal-root", className, classes.tabNavigationHorizontal),
        align: "flex-start",
        ref,
        ...rest
      },
      /* @__PURE__ */ React.createElement(Flex, { className: align === "center" && classes.tabNavigationHorizontalCenter }, /* @__PURE__ */ React.createElement("div", { style: underlineStyle, className: clsx(classes.underline, isInitialRender && classes.underlineNoTransition) }), tabs.map(({ id, text, ...restTabProps }, index) => {
        const tabId = id || text;
        return /* @__PURE__ */ React.createElement(
          Tab,
          {
            role: "tab",
            type: "button",
            id: tabId,
            key: tabId,
            text,
            "aria-selected": selectedTab === tabId,
            "aria-expanded": selectedTab === tabId,
            ref: (el) => tabRefs.current[index] = el,
            onClick: () => {
              if (isInitialRender) {
                setIsInitialRender(false);
              }
              setSelectedTab(tabId);
              onTabClick?.(tabId);
            },
            ...restTabProps
          }
        );
      }))
    );
  }
);

export { TabbedNavigationHorizontal };
